"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayHtVoiceEmotion = void 0;
exports.PlayHtVoiceEmotion = {
    FemaleHappy: "female_happy",
    FemaleSad: "female_sad",
    FemaleAngry: "female_angry",
    FemaleFearful: "female_fearful",
    FemaleDisgust: "female_disgust",
    FemaleSurprised: "female_surprised",
    MaleHappy: "male_happy",
    MaleSad: "male_sad",
    MaleAngry: "male_angry",
    MaleFearful: "male_fearful",
    MaleDisgust: "male_disgust",
    MaleSurprised: "male_surprised",
};
